const titlePartial = `
{% if pageData["enterprise_setting"]["show_name"] %}
<title>{{pageData["enterprise_setting"]["show_name"]|default(i18n.lang_0, true)}}</title>
{% else %}
<title>{{i18n.lang_0}}</title>
{% endif %}
{% if pageData["enterprise_setting"]["logo_web_tag"] %}
<link id="favicon" rel="shortcut icon" href='{{pageData["enterprise_setting"]["logo_web_tag"]|default("", true) }}' />
{% endif %}
`

const render = () => {
    return titlePartial;
};

export default render;
